/*
  FOTILE – site "Live chat" buttons → Salesforce Messaging for Web (MIAW)
  Paste into: assets/component-bst-salesforce-chat.js (replace everything)
  Replaces the old Live Agent (embedded_svc / la1) loader so only ONE chat system loads.
*/
(() => {
  const LAUNCH_SELECTOR = '[data-bst-salesforce-chat-launch]';
  const LOADER_SELECTOR = '[data-bst-salesforce-chat-loader]';
  const TIMEOUT_MS = 15000;
  const FALLBACK_URL = '/pages/contact-us';

  const api = () => window.embeddedservice_bootstrap && window.embeddedservice_bootstrap.utilAPI;
  const isReady = () => Boolean(api() && typeof api().launchChat === 'function');

  const setLoading = (button, on) => {
    button.classList.toggle('is-loading', on);
    button.toggleAttribute('aria-busy', on);
    button.disabled = on;
    const loader = button.querySelector(LOADER_SELECTOR);
    if (loader) loader.setAttribute('aria-hidden', on ? 'false' : 'true');
  };

  const waitForReady = () =>
    new Promise((resolve, reject) => {
      if (isReady()) return resolve();
      const started = Date.now();
      const poll = setInterval(() => {
        if (isReady()) { clearInterval(poll); resolve(); }
        else if (Date.now() - started > TIMEOUT_MS) { clearInterval(poll); reject(new Error('timeout')); }
      }, 250);
    });

  const showOfflineNote = (button) => {
    let note = button.parentElement && button.parentElement.querySelector('.bst-chat-offline-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'bst-chat-offline-note';
      note.setAttribute('role', 'status');
      note.style.cssText = 'margin:8px 0 0;font-size:13px;line-height:1.4;color:#5c5c5c;';
      button.insertAdjacentElement('afterend', note);
    }
    note.innerHTML = 'Live chat is available daily 9:00 AM – 8:30 PM ET. Call or text <a href="tel:+18883150366">1 (888) 315-0366</a> or email <a href="mailto:serviceusa@fotile.com">serviceusa@fotile.com</a>.';
  };

  const openChat = async (event) => {
    const button = event.currentTarget;
    if (button.classList.contains('is-loading')) return;
    event.preventDefault();
    setLoading(button, true);
    try {
      await waitForReady();
      if (window.__bstMessagingOpen === false) { showOfflineNote(button); return; }
      await api().launchChat();
    } catch (e) {
      if (window.__bstMessagingOpen === false) showOfflineNote(button);
      else window.location.href = FALLBACK_URL;
    } finally {
      setLoading(button, false);
    }
  };

  const bind = (root = document) => {
    root.querySelectorAll(LAUNCH_SELECTOR).forEach((button) => {
      if (button.dataset.bstSalesforceChatBound === 'true') return;
      button.dataset.bstSalesforceChatBound = 'true';
      button.addEventListener('click', openChat);
    });
  };

  const init = () => {
    document.documentElement.classList.add('bst-salesforce-chat-active');
    bind();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', (e) => bind(e.target));
})();
